export default __webpack_public_path__ + "static/media/PumpPower.6a66ab0c.PNG";